import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AdminAssignedToDropdown from './components/AdminAssignedToDropdown';
import { arrayType } from '../../../../constants/proptype-validation';
import ToolTip from './components/ToolTip';

class TableRow extends PureComponent {
  static displayName = 'TableRow';

  static propTypes = {
    name: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    description: PropTypes.string,
    pos: PropTypes.number.isRequired,
    save: PropTypes.func,
    serverData: arrayType,
  };

  constructor() {
    super(...arguments);

    this.state = {
      currentList: null,
    };
  }

  _edit() {
    return (
      <AdminAssignedToDropdown
        name={this.props.name}
        serverData={this.props.serverData}
        saveAssignees={(assignees) => this.props.save({ assignees })}
      />
    );
  }

  render() {
    const rowClasses = classnames('row tablerow', {
      'darkrow': this.props.pos % 2 === 0,
      'lightrow': this.props.pos % 2 !== 0,
    });

    return (
      <div className={rowClasses}>
        <div className="col-5 admin-table-cell-name">
          {this.props.role}
        </div>
        <div className="col-7 admin-table-cell-dropdown" style={{ lineHeight: 0 }}>
          {this._edit()}
        </div>
        <div className="admin-table-cell-tooltip">
          {this.props.description ? <ToolTip hoverText={this.props.description} /> : null}
        </div>
      </div>
    );
  }
}

export default TableRow;

